import { render, staticRenderFns } from "./processing-leads.vue?vue&type=template&id=18240690"
import script from "./processing-leads.vue?vue&type=script&lang=js"
export * from "./processing-leads.vue?vue&type=script&lang=js"
import style0 from "./processing-leads.vue?vue&type=style&index=0&id=18240690&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports